<template>
  <div class="custom-background" :key="componentKey">
    <!-- Blur overlay for non-signed in users -->



    <!-- Breadcrumb -->
    <div class="container skeleton-container">
      <div v-if="loading" class="hyperlinkstop text-uppercase">
        <div class="skeleton skeleton-text" style="width: 30%;"></div>
      </div>
      <b-breadcrumb v-else :items="breadcrumbItems" class="hyperlinkstop text-uppercase"></b-breadcrumb>

      <!-- Job Title Section -->
      <div class="pt-3 pb-3">
        <div class="row no-gutters align-items-center d-flex justify-content-between">
          <!-- <div class="col-md-2">
            <div v-if="loading" class="skeleton skeleton-logo"></div>
            <span v-else class="b-avatar badge-info rounded-circle" style="width:7rem;height: 7rem; background-color: #fff">
              <span class="b-avatar-img">
                <span v-if="jobData.companyLogoAddress != null && jobData.companyLogoAddress != ''">
                  <img :src="url+jobData.companyLogoAddress">
                </span>
                <span v-else>
                  <img src="../../assets/images/no-image.png">
                </span>
              </span>
            </span>
          </div> -->
          <div class="col-md-7">
            <div>
              <div v-if="loading">
                <div class="skeleton skeleton-title"></div>
                <div class="skeleton skeleton-text" style="width: 40%;"></div>
                <div class="row no-gutters">
                  <div class="col-sm-4">
                    <div class="skeleton skeleton-text"></div>
                  </div>
                  <div class="col-sm-3">
                    <div class="skeleton skeleton-text"></div>
                  </div>
                  <div class="col-sm-5">
                    <div class="skeleton skeleton-text"></div>
                  </div>
                </div>
                <div class="row no-gutters">
                  <div class="col-lg-3">
                    <div class="skeleton skeleton-badge"></div>
                  </div>
                  <div class="col-lg-3">
                    <div class="skeleton skeleton-badge"></div>
                  </div>
                  <div class="col-lg-3">
                    <div class="skeleton skeleton-badge"></div>
                  </div>
                </div>
              </div>
              <div v-else>
                <h2 class="custom-job-title text-uppercase mb-2">
                  <span v-if="jobData.jobTitle != null">{{ jobData.jobTitle }}</span>
                  <span v-else>--</span>
                </h2>
                <!-- <div class="mb-2 custom-muted-text">
                  <span v-if="$auth.check()">
                    <router-link
                      v-if="$auth.user().user.role == 'Employee'"
                      class="text-decoration-none"
                      :to="{ name: 'AboutEmployer', params: { id: setCompanyId } }"
                      title="Company Detail">
                      <span>{{ jobData.companyName }}</span>
                    </router-link>
                    <span v-else>{{ jobData.companyName }}</span>
                  </span>
                  <span v-else>{{ jobData.companyName }}</span>
                </div> -->
                <div class="row no-gutters custom-muted-text mb-2">
                  <div class="col-sm-4">
                    <div class="custom-row">
                      <span class="mr-2"><i class="fas fa-map-marker-alt"></i></span>
                      <span> {{ jobData.cityName }}, {{ jobData.countryName }}</span>
                    </div>
                  </div>
                  <!-- <div class="col-sm-3">
                    <div class="custom-row">
                      <span class="mr-2"><b-icon icon="clock-history"></b-icon></span>
                      <span>{{ jobData.postedDate | formatDate }}</span>
                    </div>
                  </div> -->
                  <div class="col-sm-5">
                    <div class="custom-row">
                      <span class="mr-2"><i class="fas fa-money-bill"></i></span>
                      <span v-if="jobData.packageTo === 0 || jobData.packageTo === 1">Market Competitive Salary</span>
                      <span v-else>Rs {{ jobData.packageFrom }} - {{ jobData.packageTo }}/Month</span>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters mb-2">
                  <!-- <div class="col-lg-3">
                    <b-badge class="custom-status-badge" variant="primary">{{ jobData.category }}</b-badge>
                  </div>
                  <div class="col-lg-3">
                    <b-badge class="custom-status-badge" variant="primary">Experience: {{ jobData.experiencelevel }}</b-badge>
                  </div>
                  <div class="col-lg-3">
                    <b-badge class="custom-status-badge" variant="primary">{{ jobData.jobTypeTitle }}</b-badge>
                  </div>
                  <div class="col-lg-3"></div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div v-if="loading">
              <div class="skeleton skeleton-text" style="width: 50%; margin-bottom: 1rem;"></div>
              <div class="skeleton skeleton-button"></div>
              <div class="skeleton skeleton-button"></div>
            </div>
            <div v-else class="text-right">
              <!-- <span class="custom-heading-text text-black mb-2">Application ends: </span>
              <i class="text-danger">{{ jobData.jobExpiryDate | formatDate }}</i> -->
              <div v-if="$auth.check()">
                <div v-if="$auth.user().user.role == 'Employee'">
                  <div class="custom-row mb-3">
                    <span class="flex-grow-1">
                      <a @click="showOrHideModal(jobData)"
                        class="btn btn-primary custom-employer-btn custom-btn-apply-now mb-2" style="font-size: 0.75rem;">Apply</a>
                    </span>
                    <div class="pl-2 pr-2"></div>
                    <div class="">
                      <button class="btn btn-primary custom-employer-btn custom-btn-apply-now custom-btn-bookmark mb-2"
                        @click="onSavingJob(jobData)">
                        <b-icon icon="bookmark"></b-icon>
                      </button>
                    </div>
                  </div>
                  <div class="custom-row">
                    <div class="pl-1 pr-1"></div>
                    <div class="flex-grow-1">
                      <button id="popover-target-1" style="font-size: 14px !important;"
                        class="btn btn-primary btn-apply mb-2">Share Job</button>
                      <b-popover target="popover-target-1" triggers="hover" placement="bottom">
                        <div class="custom-row justify-content-center mt-2">
                          <a :href="whatsAppShareUrl" type="url" target="_blank"
     class="custom-whatsapp-icon custom-icon-style mr-2 custom-social-link">
    <i class="fab fa-whatsapp"></i>
  </a>
                          <ShareNetwork class="custom-facebook-icon custom-icon-style mr-2 custom-social-link"
                            network="facebook" :url="domainUrl+'/#'+jobUrl" :title="jobData.jobTitle"
                            :description="jobData.jobDescription">
                            <i class="fab fa-facebook-f"></i>
                          </ShareNetwork>
                          <ShareNetwork class="custom-linkedin-icon custom-icon-style custom-social-link"
                            network="linkedin" :url="domainUrl+'/#'+jobUrl" :title="jobData.jobTitle"
                            :description="jobData.jobDescription">
                            <i class="fab fa-linkedin-in"></i>
                          </ShareNetwork>
                        </div>
                      </b-popover>
                    </div>
                    <div class="pl-1 pr-1"></div>
                    <div class="flex-grow-1">
                      <a href="javascript:void(0)" @click="postCompanyId(setCompanyId)"
                        class="btn btn-primary btn-apply mb-2">View All Jobs</a>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="custom-row mb-3">
                  <span class="flex-grow-1">
                    <a @click="showOrHideModal(jobData)"
                      class="btn btn-primary custom-employer-btn custom-btn-apply-now mb-2">Apply Now</a>
                  </span>
                  <div class="pl-2 pr-2"></div>
                  <div class="">
                    <button class="btn btn-primary custom-employer-btn custom-btn-apply-now custom-btn-bookmark mb-2"
                      @click="onSavingJob(jobData)">
                      <b-icon icon="bookmark"></b-icon>
                    </button>
                  </div>
                </div>
                <div class="custom-row">
                  <div class="pl-1 pr-1"></div>
                  <div class="flex-grow-1">
                    <button id="popover-target-2" class="btn btn-primary btn-apply mb-2">Share Job</button>
                    <b-popover target="popover-target-2" triggers="hover" placement="bottom">
                      <div class="custom-row justify-content-center mt-2">
                        <a :href="'https://wa.me/?text=https://shemeanswork.com/#'+jobUrl" type="url" target="_blank"
                          class="custom-whatsapp-icon custom-icon-style mr-2 custom-social-link">
                          <i class="fab fa-whatsapp"></i>
                        </a>
                        <ShareNetwork class="custom-facebook-icon custom-icon-style mr-2 custom-social-link"
                          network="facebook" :url="domainUrl+'/#'+jobUrl" :title="jobData.jobTitle"
                          :description="jobData.jobDescription">
                          <i class="fab fa-facebook-f"></i>
                        </ShareNetwork>
                        <ShareNetwork class="custom-linkedin-icon custom-icon-style custom-social-link"
                          network="linkedin" :url="domainUrl+'/#'+jobUrl" :title="jobData.jobTitle"
                          :description="jobData.jobDescription">
                          <i class="fab fa-linkedin-in"></i>
                        </ShareNetwork>
                      </div>
                    </b-popover>
                  </div>
                  <div class="pl-1 pr-1"></div>
                  <div class="flex-grow-1">
                    <a href="javascript:void(0)" @click="postCompanyId(setCompanyId)"
                      class="btn btn-primary btn-apply mb-2">View All Jobs</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Job Detail Section -->


    <div class="bg-white pt-2 mb-4 blur-section">
      <div v-if="!$auth.check()" class="blur-overlay">
        <div class="signin-message">
          <h3>Please sign in to view full job details</h3>
          <button @click="showOrHideModal(jobData)">Sign In / Sign Up</button>
        </div>
      </div>
      <div :class="{'blur-content': !$auth.check()}">
        <div class="container">
          <div class="row">
            <div class="col-lg-8">
              <div class="pt-2 pb-4 mb-4">
                <div v-if="loading">
                  <div class="skeleton skeleton-text" style="width: 30%; margin-bottom: 1rem;"></div>
                  <div class="skeleton skeleton-section"></div>
                  <div class="skeleton skeleton-text" style="width: 30%; margin-bottom: 1rem;"></div>
                  <div class="skeleton skeleton-section"></div>
                  <div class="skeleton skeleton-text" style="width: 30%; margin-bottom: 1rem;"></div>
                  <div class="skeleton skeleton-section"></div>
                </div>
                <div v-else>
                  <div class="custom-heading-text custom-job-detail-heading mb-4" v-if="jobData.category">
                    <span class="custom-underline w-100 pb-2">Category:</span>
                  </div>
                  <div class="w3-container bg-white">
                    <div class="custom-job-detail-text">
                      <span class="custom-heading-text">{{ jobData.category }}</span>
                    </div>
                  </div>
                  <div v-if="jobData.category != 'Labour Man Power'">
                    <div class="custom-heading-text custom-job-detail-heading mb-4" v-if="jobData.jobSpecification">
                      <span class="custom-underline w-100 pb-2">Job Specifications:</span>
                    </div>
                    <div class="custom-job-detail-text">
                      <div class="text-justify">{{ jobData.jobSpecification }}</div>
                    </div>
                  </div>
                  <div v-if="jobData.category != 'Graduate - Remote and Flexible Project & Internship'">
                    <div class="custom-heading-text custom-job-detail-heading mb-4" v-if="jobData.jobDescription ">
                      <span class="custom-underline w-100 pb-2">Job Description:</span>
                    </div>
                    <div class="custom-job-detail-text">
                      <div class="text-justify">{{ jobData.jobDescription }}</div>
                    </div>
                  </div>
                  <div v-if="jobData.category == 'Graduate - Remote and Flexible Project & Internship'">
                    <div class="custom-heading-text custom-job-detail-heading mb-4" v-if="jobData.projectDescription">
                      <span class="custom-underline w-100 pb-2">Project Details:</span>
                    </div>
                    <div class="custom-job-detail-text">
                      <span>{{ jobData.projectDescription }}</span>
                    </div>
                  </div>
                  <div>
                    <div class="custom-heading-text custom-job-detail-heading mb-4" v-if="jobData.jobResponsibility">
                      <span class="custom-underline w-100 pb-2">Roles & Responsibilities:</span>
                    </div>
                    <div class="custom-job-detail-text">
                      <span>{{ jobData.jobResponsibility }}</span>
                    </div>
                  </div>
                  <div>
                    <div class="custom-heading-text custom-job-detail-heading mb-4" v-if="jobData.reward">
                      <span class="custom-underline w-100 pb-2">Rewards And Benefits:</span>
                    </div>
                    <div class="custom-job-detail-text">
                      <span>{{ jobData.reward }}</span>
                    </div>
                  </div>
                  <div v-if="jobData.category == 'Person with Disability'">
                    <div>
                      <div class="custom-heading-text custom-job-detail-heading mb-4">
                        <span class="custom-underline w-100 pb-2">Suitable disability as per job required:</span>
                      </div>
                      <div class="custom-job-detail-text">
                        <span>{{ jobData.disabilityType }}</span>
                      </div>
                    </div>
                    <div>
                      <div class="custom-heading-text custom-job-detail-heading mb-4">
                        <span class="custom-underline w-100 pb-2">Disability Certificate Obtained:</span>
                      </div>
                      <div class="custom-job-detail-text">
                        <span v-if="jobData.fitToWorkCertificate == 1">Yes</span>
                        <span v-else>No</span>
                      </div>
                    </div>
                    <div>
                      <div class="custom-heading-text custom-job-detail-heading mb-4">
                        <span class="custom-underline w-100 pb-2">Facilities available for PWD's on premises:</span>
                      </div>
                      <div class="custom-job-detail-text">
                        <span>{{ jobData.specialFacilityAvailable }}</span>
                      </div>
                    </div>
                    <div>
                      <div class="custom-heading-text custom-job-detail-heading mb-4">
                        <span class="custom-underline w-100 pb-2">Special Instructions:</span>
                      </div>
                      <div class="custom-job-detail-text">
                        <span>{{ jobData.specialInstruction }}</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="custom-heading-text custom-job-detail-heading mb-4" v-if="jobData.vLearnCourseRequired">
                      <span class="custom-underline w-100 pb-2">Vii Learn Courses:</span>
                    </div>
                    <div class="custom-job-detail-text">
                      <span>{{ jobData.vLearnCourseRequired }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
  <!-- Skills Card (smaller size) -->
  <div class="bg-light mb-3">  <!-- Added mb-3 for margin bottom -->
    <div class="pt-3 pb-3 pl-3 pr-3">  <!-- Reduced padding -->
      <div v-if="loading">
        <div class="skeleton skeleton-text" style="width: 30%; margin-bottom: 1rem;"></div>
        <div class="skeleton skeleton-text"></div>
      </div>
      <div v-else>
        <div class="custom-heading-text custom-job-overview-heading mb-3">  <!-- Reduced margin -->
          <span class="custom-underline w-100 pb-2">Skills:</span>
        </div>
        <div class="w3-container bg-white">
          <div class="custom-job-detail-text">
            <span class="custom-heading-text">{{ jobData.skill }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- More Jobs Section -->
  <div class="bg-light">
    <div class="pt-3 pb-3 pl-3 pr-3">  <!-- Reduced padding -->
      <div class="custom-heading-text custom-job-overview-heading mb-3">  <!-- Reduced margin -->
        <span class="custom-underline w-100 pb-2">More Jobs like this:</span>
      </div>

      <div v-if="loadingSimilarJobs" class="recommended-jobs-container">
        <div v-for="n in 2" :key="n" class="job-card mb-2 p-2 border rounded">  <!-- Reduced items and padding -->
          <div class="skeleton skeleton-text" style="width: 70%; height: 1.2rem;"></div>
          <div class="skeleton skeleton-text" style="width: 50%; height: 0.9rem; margin-top: 0.4rem;"></div>
          <div class="skeleton skeleton-text" style="width: 40%; height: 0.9rem; margin-top: 0.4rem;"></div>
        </div>
      </div>

      <div v-else class="recommended-jobs-container">
        <div v-for="job in similarJobs" :key="job.jobId" class="job-card mb-2 p-2 border rounded">  <!-- Reduced padding -->
          <router-link :to="{ name: 'JobDetail', params: { id: job.jobId } }" class="mt-1">
            <h5 class="job-title" style="font-size: 0.95rem;">{{ job.jobTitle }}</h5>  <!-- Reduced font size -->
            <div class="company-name" style="font-size: 0.8rem;">{{ job.companyName }}</div>  <!-- Reduced font size -->
            <div class="job-location" style="font-size: 0.75rem;">{{ job.cityName }}, {{ job.countryName }}</div>  <!-- Reduced font size -->
          </router-link>
        </div>

        <div v-if="similarJobs.length === 0" class="text-center py-2">  <!-- Reduced padding -->
          No similar jobs found
        </div>
      </div>
    </div>
  </div>
</div>
          </div>
        </div>
      </div>
    </div>

    <CPModal v-if="isModalVisible" :save-job-status="isSaveJobStatus" :signInOrSignUpSection="isSignInOrSignUpSection"
      :employeeProfileFormSection="isEmployeeProfileFormSection" :show-alert-msg="isShowAlertMsg"
      :show-profile-info-card="isShowProfileInfoCard" :apply-job-confirmation-section="isApplyJobConfirmationSection"
      :selected-job-record="jobRecord" @get-strength="recievedStrength" @toggle-modal="toggleModal"
      :istakeResumeAfterSignin="istakeResumeAfterSignin" :jobDataForResumeInputModalPopup="jobDataForModalPopup">
    </CPModal>
  </div>
</template>

<script>

import Vue from 'vue'
import axios from "axios";
import CPModal from "../../components/employeeComponents/CompleteProfileModalComponent"

import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing);

export default {
  name:"JobDetail",
  components:{
    CPModal
  },

  data(){
    return{
      isResumeTakenModalOpenOnce: sessionStorage.getItem('isResumeTakenModalOpenOnce') === 'true' || false,
      loadingSimilarJobs:false,
      similarJobs: [],
      jobData: {
      jobTitle: '',
      jobDescription: '',
      companyName: '',
      area: '',
      cityName: '',
      countryName: '',
      postedDate: '',
      packageFrom: 0,
      packageTo: 0,
      category: '',
      experiencelevel: '',
      jobTypeTitle: '',
      jobExpiryDate: '',
      jobSpecification: '',
      jobResponsibility: '',
      reward: '',
      disabilityType: '',
      fitToWorkCertificate: 0,
      specialFacilityAvailable: '',
      specialInstruction: '',
      vLearnCourseRequired: '',
      skill: '',
      industry: '',
      shift: '',
      noOfPosition: '',
      gender: '',
      degreeLevels: '',
      careerLevel: '',
      jobRequireTraveling: false,
      companyId: 0,
      companyLogoAddress: '',
      scrapjoburl:'',
      IsScrapJob:null
    },
      url:axios.defaults.baseURL,
      whatsAppUrl:"https://wa.me/?text=",
      // linkedInUrl:"https://www.linkedin.com/sharing/share-offsite/?url=",
      linkedInUrl:"http://www.linkedin.com/shareArticle?mini=true&url=",
     // http://www.linkedin.com/shareArticle?mini=true&url=&title=Web%20Application%20Developer
      domainUrl:"https://shemeanswork.com",

      fullJobUrl:"",
      jobUrl:this.$route.fullPath,
      jobData:[],
      loading: true,
      errored: false,

      rowError: false,
      rowid: 1,
      setCompanyId:0,

      degreeLevels:null,
      selectedGenderType:0,
      genderType:[

        { value: 1, text: "Male" },
        { value: 2, text: "Female" },
        { value: 3, text: "Other" },
      ],

      //Apply job
      job:{

        jobId: 0,
        employeeId: 0,
        expectedSalary: 0,
        status: 1,
        isApplicantViewed: false
      },

      saveJob:{
        saveJobId: 0,
        jobId: 0,
        employeeId: 0,
        isActive: true

      },
      isApplyNow_btn:true,

      //Complete Profile Modal
      jobID:0,
      jobRecord:null,
      jobsStatuses:null,
      employeelist:null,
      employeeId:0,
      employeeSkill:null,
      employeeExperience:null,
      employeeEducation:null,
      profileStrength:0,
      breadcrumbItems: [
                {
                    text: 'Home',
                    to: '/'
                },
                {
                    text: 'Job Board',
                    to: '/job-board'
                },
                {
                    text: ''
                }
            ],
      isSaveJobStatus:false,
      isModalVisible:false,
      isSignInOrSignUpSection:false,
      isEmployeeProfileFormSection:false,
      isShowAlertMsg:false,
      isShowProfileInfoCard:false,
      isApplyJobConfirmationSection:false,
      istakeResumeAfterSignin:false,
      modalTitle:"",
      showAlertMsg:false,
      modalDescription:"",
      componentKey:0,
      disableEasyApplyButton: false,
      showAssessmentButton: false,
      unansweredQuestions: [],
      jobDataForModalPopup: {
      title: '',
      companyName: '',
      cityName:'',
      countryName: '',
      scrapJobUrl:'',
    }
    };
  },
  watch: {
  '$route.params.id': {
    immediate: true,
    handler(newId, oldId) {
      if (newId !== oldId) {
        this.rowid = newId;
        this.getJobDetail();
        this.GetsimilarJobs();
      }
    }
  }
},
  mounted() {
      this.rowid = this.$route.params.id;
     this.GetsimilarJobs();
    this.getJobDetail();
    this.getDegreeLevel();
    this.getAllEmployees();
   
  },
  computed: {
    whatsAppShareUrl() {
      // Construct the full URL with hash
      const fullUrl = `${window.location.origin}/#${this.$route.fullPath}`;
      
      // Encode the full URL for WhatsApp
      return `https://api.whatsapp.com/send?text=${encodeURIComponent(fullUrl)}`;
    }
  },
  methods:{
    
   GetsimilarJobs() {
  this.loadingSimilarJobs = true;
  let model = {
    PageSize: 5,
    PageNumber: 1,
    TotalRecord: 0,
    Text: '',
     JobId: parseInt(this.rowid)
  };

  axios.post('/api/Job/GetJobsByIndustryType', model)
    .then(response => {
      //console.log('similar jobs data', response.data);
      // Assuming the API returns an array of jobs
      if (response.data && Array.isArray(response.data.data)) {
        this.similarJobs = response.data.data;
        //console.log('this.similarJobs',this.similarJobs)
      } else {
        console.warn('API response is not an array:', response.data);
        this.similarJobs = []; // Set to empty array if response is not as expected
      }
    })
    .catch(error => {
      console.error("Error fetching similar jobs:", error);
      this.$bvToast.toast("Error loading recommended jobs", {
        toaster: "b-toaster-top-center",
        variant: "danger",
        solid: true,
      });
      this.similarJobs = []; // Set to empty array on error
    })
    .finally(() => {
      this.loadingSimilarJobs = false;
    });
},

    getSelectedValues() {
    var radioButtons = [];
    var selectedValues = {};

    // Assuming you have radio buttons with names 'q1' to 'q24'
    for (var i = 1; i <= 24; i++) {
        radioButtons[i] = document.getElementsByName('q' + i);
        var userid =0;
        var selectedInGroup = false;

        // Loop through the radio buttons to find the selected one
        for (var j = 0; j < radioButtons[i].length; j++) {
            if (radioButtons[i][j].checked) {
              
                selectedInGroup = true;

                selectedValues['q' + i] = radioButtons[i][j].value;
                var entry = {
                  JobId: this.jobId,
                  UserId: userid,
                  Username: "test",
                  QuestionNo: radioButtons[i][j].name,
                  Answers: radioButtons[i][j].value
                };
                this.SelectedValues.push(entry);
                break;
            }
        }
        if (!selectedInGroup) {
          // Record unanswered question number
          this.unansweredQuestions.push(i);
        }
      }

      if (this.unansweredQuestions.length > 0) {
        // Show an alert or handle unanswered questions as needed
        alert('Please select an option for questions: ' + this.unansweredQuestions.join(', '));
        // Clear the unanswered questions array for the next attempt
        this.unansweredQuestions = [];
        return;
      }
    
    //console.log(this.SelectedValues);
    this.disableEasyApplyButton = true;


    // const modal = document.getElementById('surveyModal');
    // modal.style.display = 'none';


    axios
          .post("/api/Job/InsertAssesment", this.SelectedValues)
          .then(res => {
            // code that we will 'try' to run
            
            //console.log("InsertAssesment",res);
            //console.log("InsertAssesment data" ,res.data);
            //console.log("InsertAssesment data2" ,res.data.data);
            if(res.data.data == 3000){
              alert('Already submitted the Assessment!');
                window.location.reload();  
            }
            if(res.data.data == 2000){
              alert('Assesment saved Successfully!');
                window.location.reload(); 
            }
          })
          .catch(error => {
            //console.log("Errorrrrrr : ", error);
            this.errored = true;
          })
      //console.log(selectedValues);
},
    //shows detail per record
    getJobDetail() {
     
      this.loading = true; // Ensure loading is true at start
      //console.log("jobUrl : ",this.jobUrl)
      this.fullJobUrl = encodeURIComponent(this.domainUrl+'/#'+this.jobUrl);
      //console.log("encUrl : ",this.fullJobUrl)



      this.rowid = this.$route.params.id;
      //console.log("params : ",this.$route.fullPath);
      //console.log("rowid : ",this.rowid);
      axios
          .get("/api/Job/Get?jobId="+this.rowid)
          .then((response) => {
  this.jobData = response.data.data;
  if(this.jobData.packageTo === 0){
    this.jobData.packageFrom = null;
  }
  //console.log("one", this.jobData.area);
  this.setCompanyId= this.jobData.companyId;
  this.breadcrumbItems[2].text = this.jobData.jobTitle;
})

          .catch((error) => {
            //console.log(error);
            this.$bvToast.toast("No Data Found", {
              toaster: "b-toaster-top-center",
              variant: "primary",

              solid: true,
            });
          })
          .finally(() =>{
            this.loading=false;
          });
    },
    getDegreeLevel() {
      this.degreeLevels = null;
      axios.get('/api/DegreeLevel/GetAll')
          .then(res =>{
            if (res.status != '200') {
              //console.log('error.....')
              const error = new Error('Failed to fetch!');
              return error;
            }


            /*forEach((item, index) => {
          const country = {
            id: item.gnId,
            title: item.name,
          };*/
            this.degreeLevels = res.data.data;
            //console.log("degreeLevel : ", this.degreeLevels);
            // });
          }).catch(error => {
        //console.log(error);
        this.errored = true;
      })
          .finally(() => {
            if (this.errored) {

              //console.log("Error : Sorry there is no response");
              // this.$bvToast.toast("Sorry there is no response ", {
              //   toaster: "b-toaster-top-center",
              //   variant: "danger",

              //   solid: true,
              // });
            }
          });

    },

    getAllEmployees(){
      this.rerender();
      //this.profileStrength = 0;
      this.employeelist = null;
      axios.get('/api/Employee/GetEmployeeProfile')
          .then(res =>{
            if (res.status != '200') {
              //console.log('error.....')
              const error = new Error('Failed to fetch!');
              return error;
            }



            this.employeelist = res.data.employee;
            //console.log("employeelist : ", this.employeelist);


            this.employeeId = this.employeelist.employeeId;
            this.job.expectedSalary = this.employeelist.expectedSalary;

            this.employeeSkill = res.data.eMPSkills;
            //console.log("employeeSkill : ", this.employeeSkill);
            this.employeeExperience = res.data.eMPExperiences;



            this.employeeEducation = res.data.empEducations;
            //console.log("employeeEducation : ", this.employeeEducation);


            this.CalculatePercentage();
            //this.appliedJobsStatus();

            // });
          }).catch(error => {
        //console.log(error);
        this.errored = true;
      })
          .finally(() => {
            if (this.errored) {

              //console.log("Error : Sorry there is no response");
              // this.$bvToast.toast("Sorry there is no response ", {
              //   toaster: "b-toaster-top-center",
              //   variant: "danger",

              //   solid: true,
              // });
            }
          });
    },
    postCompanyId(cId){
      this.$router.push(
          { name: 'AllJobs', params:{cId} })
      //console.log("companyId: ", cId)
      // this.$store.dispatch("getJobsByCompanyId", cId);
    },
    // showOrHideModal(jobrecord){
    //   this.jobRecord = jobrecord;
    //   this.jobDataForModalPopup = {
    //       title: jobrecord.jobTitle || '',
    //       companyName: jobrecord.companyName || '',
    //       countryName: jobrecord.countryName || '',
    //       scrapJobUrl: jobrecord.scrapjoburl || '',
    //       cityName: jobrecord.cityName || '',
    //     };
    //   if (this.$auth.check()) {
    //     //console.log("chek : ", this.$auth.check());
    //     //this.$router.push({ name: "JobDetail" });
    //     if (!this.isResumeTakenModalOpenOnce || this.employeelist.resume != null || this.employeelist.resume != '' ) {

    //       this.isModalVisible = true;
    //       this.istakeResumeAfterSignin = true;
    //       this.isSignInOrSignUpSection = false;
    //       this.isEmployeeProfileFormSection = false;
    //       this.isShowAlertMsg = false;
    //       this.isShowProfileInfoCard = false;
    //       this.isApplyJobConfirmationSection = false;
    //       this.isResumeTakenModalOpenOnce=true;
    //     }else{
    //       const jobUrl =jobrecord ?.scrapJobUrl;
    //         if (jobUrl && typeof jobUrl === 'string' && jobUrl.startsWith('http')) {
    //           window.open(jobUrl, '_blank') || alert('Please allow popups for this site to open the job URL.');
    //         } else {
    //           console.error('Invalid or missing job URL:', jobUrl);
    //           alert('Cannot open job URL: Invalid or missing URL.');
    //         }
    //     }
        




    //     // if(this.profileStrength > 80){
    //     //   //console.log("total strength inside if statement after Employee Skill section: ", this.profileStrength)

    //     //   this.isModalVisible = true;

    //     //   this.isSignInOrSignUpSection = false;
    //     //   this.isEmployeeProfileFormSection = true;
    //     //   this.isShowAlertMsg = false;
    //     //   this.isShowProfileInfoCard = true;
    //     //   this.isApplyJobConfirmationSection = true;
    //     //   //console.log("job strength inside if statement: ",this.profileStrength)
    //     //   //console.log("jobRecord inside if statement: ",this.jobRecord)
    //     // }
    //     // else{
    //     //   this.$bvToast.toast("Your profile Strength Must be Over 80%, Please Update your Profile", {
    //     //     toaster: "b-toaster-top-center",
    //     //     variant: "warning",

    //     //     solid: true
    //     //   });

    //     //   this.isModalVisible = true;
    //     //   //console.log("job strength inside else statement: ",this.profileStrength)

    //     //   this.isSignInOrSignUpSection = false;
    //     //   this.isEmployeeProfileFormSection = true;
    //     //   this.isShowAlertMsg = true;
    //     //   this.isShowProfileInfoCard = false;
    //     //   this.isApplyJobConfirmationSection = false;



    //     // }


    //   }
    //   else{
    //     //console.log("chek : ",this.$auth.check());
    //     this.isModalVisible = true;
    //     this.isEmployeeProfileFormSection = false;
    //     //this.modalTitle = "Attention";
    //     this.isSignInOrSignUpSection=true;
    //     this.isShowAlertMsg = false;
    //     this.isShowProfileInfoCard = false;
    //     this.isApplyJobConfirmationSection = false;
    //     //this.modalDescription = "Please Register/Login Before Applying a Job"
    //   }
    // },
showOrHideModal(jobrecord) {
  this.jobRecord = jobrecord;
  this.jobDataForModalPopup = {
    title: jobrecord.jobTitle || '',
    companyName: jobrecord.companyName || '',
    countryName: jobrecord.countryName || '',
    scrapJobUrl: jobrecord.scrapjoburl || '',
    cityName: jobrecord.cityName || '',
  };

  if (this.$auth.check()) {
    //console.log("check : ", this.$auth.check());
    
    // Check if user has resume or modal was already opened once
    if ((this.employeelist.resume && this.employeelist.resume !== '') && this.isResumeTakenModalOpenOnce) {
      
      // For scrap jobs - redirect to external URL
      if (jobrecord.isScrapJob && jobrecord.scrapjoburl) {
        const jobUrl = jobrecord.scrapjoburl;
        if (typeof jobUrl === 'string' && (jobUrl.startsWith('https') || jobUrl.startsWith('http'))) {
          window.open(jobUrl, '_blank') || 
            alert('Please allow popups for this site to open the job URL.');
        } else {
          console.error('Invalid or missing job URL:', jobUrl);
          alert('Cannot open job URL: Invalid or missing URL.');
        }
      } 
      // For regular jobs - proceed with application
      // else {
      //   this.isModalVisible = true;
      //   this.istakeResumeAfterSignin = false;
      //   this.isSignInOrSignUpSection = false;
      //   this.isEmployeeProfileFormSection = false;
      //   this.isShowAlertMsg = false;
      //   this.isShowProfileInfoCard = false;
      //   this.isApplyJobConfirmationSection = true;
      // }
    } 
    // No resume and first time - open resume modal
    else {
      this.isModalVisible = true;
      this.istakeResumeAfterSignin = true;
      this.isSignInOrSignUpSection = false;
      this.isEmployeeProfileFormSection = false;
      this.isShowAlertMsg = false;
      this.isShowProfileInfoCard = false;
      this.isApplyJobConfirmationSection = false;
      this.isResumeTakenModalOpenOnce = true;
      sessionStorage.setItem('isResumeTakenModalOpenOnce', 'true');
    }
  } 
  // Not logged in - show sign in modal
  else {
    //console.log("check : ", this.$auth.check());
    this.isModalVisible = true;
    this.isEmployeeProfileFormSection = false;
    this.isSignInOrSignUpSection = true;
    this.isShowAlertMsg = false;
    this.isShowProfileInfoCard = false;
    this.isApplyJobConfirmationSection = false;
  }
},
    onSavingJob(jobrecord){
      this.jobRecord = jobrecord;
      if(this.$auth.check()){
        this.saveJob.jobId = Number(jobrecord.jobId);
        this.saveJob.employeeId = Number(this.employeeId);
        //console.log("jobId + Emp ID : ", this.saveJob.jobId + this.saveJob.employeeId)
        axios
            .post("/api/Job/SaveJob", this.saveJob)
            .then(res => {
              // code that we will 'try' to run
              this.info = res.data;

              //console.log("Add Response portion");

              //console.log("response : ", this.info.msg);
            })
            .catch(error => {
              //console.log("Errorrrrrr : ",error);
              this.errored = true;
            })
            .finally(() => {


              if(this.info.msg == "Job Already Save"){
                this.$bvToast.toast("You have Saved to the Job Already. ", {
                  toaster: "b-toaster-top-center",
                  variant: "warning",

                  solid: true
                });
              }
              else {
                this.$bvToast.toast("Job Saved Successfully", {
                  toaster: "b-toaster-top-center",
                  variant: "success",

                  solid: true
                });
              }
              this.getAll();
              this.getAllEmployees();


            });
      }
      else {
        this.$bvToast.toast("Please Register / Log In, Before Saving a job", {
          toaster: "b-toaster-top-center",
          variant: "warning",

          solid: true
        });
        setTimeout(this.showSignUpOrSignInModal(),1000)
      }

    },
    showSignUpOrSignInModal(){
      this.isModalVisible = true;
      this.isSaveJobStatus = true;
      this.isEmployeeProfileFormSection = false;

      this.isSignInOrSignUpSection=true;
      this.isShowAlertMsg = false;
      this.isShowProfileInfoCard = false;
      this.isApplyJobConfirmationSection = false;
    },

    toggleModal(){
      this.isModalVisible = !this.isModalVisible;
      this.getAllEmployees();
    },



    recievedStrength(value){
      this.profileStrength = value;
      //console.log("On Home Page: ", this.profileStrength);

    },
    //Rerender Component
    rerender() {
      this.componentKey += 1;
    },
    CalculatePercentage() {

      //Employee

      let profilePercentUponSignUp = 50;
      let profilePercent = 40;
      // let expPercent = 20;
      // let eduPercent = 20;
      let skillPercent = 10;

      let percent = 0;

      if(this.employeelist != {}){
        if((this.employeelist.fullName != "" || this.employeelist.fullName != null) && (this.employeelist.mobileNumber != "" || this.employeelist.mobileNumber != null)){
          percent += profilePercentUponSignUp;
          //console.log("percent in signup : ", percent)
        }

        this.profileStrength = Math.ceil(percent);
        //console.log("total after Employee section : ", this.profileStrength);



      // if (this.employeelist.fatherName != "" && this.employeelist.fatherName != null && this.employeelist.cnic != "" && this.employeelist.dateofBirth != null && this.employeelist.gender != 0 && this.employeelist.gender != null) {
      if (this.employeelist.gender != 0 && this.employeelist.gender != null) {
      
        percent += profilePercent;

          //console.log("percent in Profile : ", percent)
        }
        this.profileStrength = Math.ceil(percent);
        //console.log("total after Employee section : ", this.profileStrength);

      }

      this.profileStrength = Math.ceil(percent);
      //console.log("total after Employee section : ", this.profileStrength);


      // if(this.employeeExperience.length != 0){
      //   percent += expPercent;

      // }

      // this.profileStrength = Math.ceil(percent);
      // //console.log("total after Employee Experience section : ", this.profileStrength);





      // if(this.employeeEducation.length != 0){
      //   percent += eduPercent;

      // }

      // this.profileStrength = Math.ceil(percent);
      // //console.log("total after Employee Education section : ", this.profileStrength);



      if(this.employeeSkill.length != 0){
        percent += skillPercent;

      }

      this.profileStrength = Math.ceil(percent);
      //console.log("total after Employee Skill section : ", percent);


    },
  }
}
</script>
<style scoped>
/* Add these new styles */
.blur-section {
  position: relative;
}

.blur-content {
  filter: blur(3px);
  pointer-events: none;
}

.blur-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  /* height: 100%; */
  display: flex;
  justify-content: center;
  /* align-items: center; */
  z-index: 10;
}

.signin-message {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 80%;
  z-index: 11; /* Higher than blur-overlay */
  position: relative; /* Needed for z-index to work */
}

.signin-message button {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background-color: #ea216c;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.common_banner_text .breadcrumb {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}


.hyperlinkstop::before {
  color: black;
}
.hyperlinkstop{
  display: flex;
  justify-content: center;
  padding-top: 10px;
  background: #f5f6f8;
  text-decoration: none;
  font-weight: 700;
  font-size: larger;
}
.hyperlinkstop li:active {
  color:#ea216c;
}
@media screen and (max-width: 720px) {
  .hyperlinkstop{
  display: flex;
  justify-content: center;
  padding-top: 10px;
  background: #f5f6f8;
  text-decoration: none;
  font-weight: 700;
  font-size: smaller;
}
  
}
.skeleton {
  background-color: #e0e0e0;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

/* Shimmer animation */
.skeleton::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: shimmer 1.5s infinite;
}

/* Animation keyframes */
@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* Specific skeleton styles */
.skeleton-logo {
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
}

.skeleton-title {
  width: 60%;
  height: 2.5rem;
  margin-bottom: 1rem;
}

.skeleton-text {
  width: 100%;
  height: 1.5rem;
  margin-bottom: 0.5rem;
}

.skeleton-badge {
  width: 100px;
  height: 1.5rem;
  display: inline-block;
  margin-right: 0.5rem;
}

.skeleton-button {
  width: 120px;
  height: 2.5rem;
  margin-bottom: 1rem;
}

.skeleton-section {
  width: 100%;
  height: 10rem;
  margin-bottom: 1rem;
}

/* Ensure skeleton aligns with your layout */
.container.skeleton-container {
  padding: 1rem;
}

/* Adjust for responsive design */
@media screen and (max-width: 720px) {
  .skeleton-title {
    width: 80%;
  }
  .skeleton-text {
    width: 90%;
  }
}
.recommended-jobs-container {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
}

.job-card {
  transition: all 0.3s ease;
  background: white;
  position: relative;
}

.job-card:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  transform: translateY(-2px);
}

.job-title {
  color: #2c3e50;
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.company-name {
  color: #7f8c8d;
  font-size: 0.85rem;
  margin-bottom: 0.25rem;
}

.job-location {
  color: #3498db;
  font-size: 0.8rem;
}

.btn-view-details {
  position: absolute;
  right: 15px;
  bottom: 15px;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

@media (max-width: 768px) {
  .recommended-jobs-container {
    padding: 10px;
  }
  
  .job-card {
    padding: 15px;
  }
}
.job-location{
  color: none !important;
}
</style>